// bingoContent.ts

export interface BingoContentSet {
  id: string;
  name: string;
  description?: string;
  items: string[];
  suggestedGridSize?: number;
  includeFreeCenter?: boolean;
  // Used on the print layout (8.5 x 11)
  printTitle: string;
}

// AWS Web Services Bingo
export const awsWebServicesContent: BingoContentSet = {
  id: "aws-web-services",
  name: "AWS Web Services",
  description: "Common AWS services and building blocks.",
  suggestedGridSize: 5,
  includeFreeCenter: true,
  printTitle: "AWS Web Services Bingo",
  items: [
    "EC2",
    "S3",
    "Lambda",
    "API Gateway",
    "DynamoDB",
    "RDS",
    "Aurora",
    "CloudFront",
    "VPC",
    "IAM",
    "CloudWatch",
    "CloudTrail",
    "Elastic Beanstalk",
    "ECS",
    "EKS",
    "Fargate",
    "Route 53",
    "SNS",
    "SQS",
    "Kinesis",
    "Redshift",
    "Glue",
    "Step Functions",
    "CodeCommit",
    "CodeBuild",
    "CodePipeline",
    "CodeDeploy",
    "Secrets Manager",
    "Systems Manager",
    "S3 Glacier",
    "Athena",
    "QuickSight",
    "Elasticache",
    "OpenSearch",
    "Bedrock",
    "SageMaker",
    "EventBridge",
    "Organization",
    "Control Tower",
    "WAF",
    "Shield",
    "GuardDuty",
    "Inspector",
    "Backup",
    "Elastic Load Balancing",
    "ALB",
    "NLB",
    "CloudFormation",
    "CDK"
  ]
};

// Colorado Trivia Bingo
export const coloradoTriviaContent: BingoContentSet = {
  id: "colorado-trivia",
  name: "Colorado Trivia",
  description: "Fun facts and landmarks from all over Colorado.",
  suggestedGridSize: 5,
  includeFreeCenter: true,
  printTitle: "Colorado Trivia Bingo",
  items: [
    "Denver",
    "Rocky Mountain National Park",
    "Fourteeners",
    "Pikes Peak",
    "Garden of the Gods",
    "Great Sand Dunes",
    "Mesa Verde",
    "Colorado Springs",
    "Fort Collins",
    "Boulder",
    "I-70",
    "Ski Resorts",
    "Vail",
    "Aspen",
    "Breckenridge",
    "Telluride",
    "Maroon Bells",
    "San Juan Mountains",
    "Continental Divide",
    "Colorado River",
    "Legalized Cannabis",
    "Centennial State",
    "Coors Brewery",
    "Red Rocks Amphitheatre",
    "Broncos",
    "Nuggets",
    "Avalanche",
    "Rockies Baseball",
    "Elevation 5280",
    "State Capital Dome",
    "Durango & Silverton Train",
    "Royal Gorge Bridge",
    "Palisade Peaches",
    "Olathe Sweet Corn",
    "Buffaloes",
    "Wildfires",
    "300 Days of Sunshine",
    "Blue Columbine",
    "State Flag",
    "Ski Pass",
    "I-25 Traffic",
    "Front Range",
    "Western Slope",
    "High Plains",
    "Snowstorm in May",
    "Afternoon Thunderstorms",
    "Craft Breweries",
    "Tech Startups",
    "Ski Traffic"
  ]
};

// Boulder Colorado Trivia Bingo
export const boulderColoradoTriviaContent: BingoContentSet = {
  id: "boulder-trivia",
  name: "Boulder, Colorado Trivia",
  description: "Local Boulder landmarks, culture, and inside jokes.",
  suggestedGridSize: 5,
  includeFreeCenter: true,
  printTitle: "Boulder, Colorado Trivia Bingo",
  items: [
    "Flatirons",
    "Pearl Street Mall",
    "CU Buffs",
    "Folsom Field",
    "Boulder Creek",
    "Boulder Canyon",
    "Chautauqua Park",
    "NCAR",
    "Baseline Road",
    "Sunset over Flatirons",
    "Eldorado Canyon",
    "Boulder Farmers Market",
    "Boulderado Hotel",
    "The Hill",
    "Bike Lanes Everywhere",
    "Electric Scooters",
    "Climbing Gyms",
    "Tech Startups",
    "Organic Grocery Stores",
    "Gluten-Free Everything",
    "Yoga Studios",
    "Meditation Centers",
    "Tea House",
    "Views of Longs Peak",
    "Flagstaff Road",
    "Sanitas Trail",
    "Green Mountain",
    "Snow then Sunshine",
    "E-Bikes",
    "Boulder Bubble",
    "Roundabouts",
    "Food Trucks",
    "Wild Turkeys",
    "Prairie Dogs",
    "Bear Sightings",
    "Boulder Reservoir",
    "Plan-Boulder",
    "Startup Week",
    "Boulder Theater",
    "Celestial Seasonings",
    "Windy Afternoons",
    "14ers Nearby",
    "Clif Bars in Backpacks",
    "Farm-to-Table Restaurants",
    "Remote Workers in Cafes",
    "CU Norlin Library",
    "Buffalo Statue",
    "Google Campus",
    "Street Performers"
  ]
};

export const allContentSets: BingoContentSet[] = [
  awsWebServicesContent,
  coloradoTriviaContent,
  boulderColoradoTriviaContent
];
